import React from 'react';
import { STATS } from '../../data/catio';

/** Slim proof line under the hero — compact, light, separated by small orange marks. */
export function ValueStrip() {
  return <section aria-label="What's in the collection" className="bg-ivory" data-id="element-300" data-mp="2gkfbrkayxrvy">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-301" data-mp="2gkozt2cgdoz0">
        <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 border-y border-line/70 py-4 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-x-0 sm:py-5" data-id="element-302" data-mp="2bmdtv2pa3ym2">
          {STATS.map((stat, index) => <li key={stat.label} className="flex items-baseline gap-2 sm:items-center" data-id="element-303" data-mp="34b2oqjzqr7pd" data-mpi={index}>
              {index > 0 && <span className="mx-6 hidden h-1 w-1 rotate-45 bg-ember sm:inline-block lg:mx-9" aria-hidden data-id="element-304" data-mp="2zhgipao3222j" />}
              <span className="font-display text-[1.3rem] leading-none text-ink sm:text-[1.45rem]" data-id="element-305" data-mp="3s0dqa3ox164k">
                {stat.value}
              </span>
              <span className="label-tech text-graphite" data-id="element-306" data-mp="1ab4k0lf4tlzp">
                {stat.label}
                {stat.accent && <span className="text-ember" data-id="element-307" data-mp="1fa7nw2jdlm63"> {stat.accent}</span>}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}